<template>
  <div class="page-content">
    <page-template ref="addColumn"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :addColumns="addColumns"
                   :editColumns="addColumns"
    ></page-template>
    <el-dialog title="金额查询" :visible.sync="isShow" center width="100px">
      <div class="setCode">
        <div class="button">
          运费余额：
          <el-input disabled placeholder='暂无数据' v-model="deliverBalance" maxlength="13">></el-input>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          红包余额：
          <el-input disabled placeholder="暂无数据" v-model="redPacketBalance" maxlength="13">></el-input>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="充值" :visible.sync="isMoneyShow" center width="100px">
      <div class="setCode">
        <div class="button">
          金额：
          <el-input v-model="money" maxlength="13">></el-input>
          <el-button type="primary" @click="rechargeMoney()">充值</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 注册达达账号 -->
    <el-dialog title="添加达达账号" :visible.sync="addDadaVisible" center width="100px">
      <div class="dialog-body">
        <el-form ref="registDadaForm" :model='registFormData' :rules='registFormRules' label-width='100px' style="display:flex">
          <div style="width:50%">
            <el-form-item label='手机号' prop='mobile'>
              <el-input placeholder="请输入达达商户注册手机号" v-model="registFormData.mobile"></el-input>
            </el-form-item>
            <el-form-item label='企业全称' prop='enterpriseName'>
              <el-input placeholder="请输入企业全程" v-model="registFormData.enterpriseName"></el-input>
            </el-form-item>
            <el-form-item label='联系人姓名' prop='contactName'>
              <el-input placeholder="请输入联系人姓名" v-model="registFormData.contactName"></el-input>
            </el-form-item>
            <el-form-item label='邮箱地址' prop='email'>
              <el-input placeholder="请输入邮箱地址" v-model="registFormData.email"></el-input>
            </el-form-item>
          </div>
          <div style="width:50%">
            <el-form-item label='商户城市名称' prop='cityName'>
              <el-input placeholder="请输入商户城市名称如：苏州" v-model="registFormData.cityName"></el-input>
            </el-form-item>
            <el-form-item label='企业地址' prop='enterpriseAddress'>
              <el-input placeholder="请输入企业详细地址" v-model="registFormData.enterpriseAddress"></el-input>
            </el-form-item>
            <el-form-item label='联系人电话' prop='contactPhone'>
              <el-input placeholder="请输入联系人手机号" v-model="registFormData.contactPhone"></el-input>
            </el-form-item>
            <el-form-item label='商户编号' prop='resultId'>
              <el-input placeholder="请输入商户编号" v-model="registFormData.resultId"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog-footer">
        <el-button type='primary' @click="submitAddDada()">添加</el-button>
        <el-button type='primary' @click="registData()">注册</el-button>
        <el-button type='default' @click="reset()">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import pageTemplate from "@/components/template/pageTemplate";
import api from "@/config/api";
import addForm from "@/components/template/add";

export default {
  components: {
    pageTemplate,
    addForm,
  },
  data() {
    return {
      // registFormData:{
      //   mobile:'',
      //   cityName:'',
      //   enterpriseName:'',
      //   enterpriseAddress:'',
      //   contactName:'',
      //   contactPhone:'',
      //   email:'',
      //   resultId:''
      // },
      registFormData:{
        cityName: "",
        contactName: "",
        contactPhone: "",
        email: "",
        enterpriseAddress: "",
        enterpriseName: "",
        merchantId: "",
        mobile: "",
        resultId: ""
      },
      registFormRules:{
        mobile:[
          {required: true, message: "手机号", trigger: "blur"},
          {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
        ],
        cityName:[
          {required: true, message: "商户城市名称", trigger: "blur"},
        ],
        enterpriseName:[
          {required: true, message: "企业全称", trigger: "blur"},
        ],
        enterpriseAddress:[
          {required: true, message: "企业地址", trigger: "blur"},
        ],
        contactName:[
          {required: true, message: "联系人姓名", trigger: "blur"},
        ],
        contactPhone:[
          {required: true, message: "联系人电话", trigger: "blur"},
        ],
        email:[
          {required: true, message: "邮箱地址", trigger: "blur"},
        ],
        resultId:[
          {required: true, message: "商户编号", trigger: "blur"},
        ]
      },
      isShow: false,
      isMoneyShow: false,
      addDadaVisible: false,
      form: '',
      deliverBalance: '',
      redPacketBalance: '',
      money: '',
      // 高级搜索条件
      searchOptions: {
        simple: [
          {
            label: "手机号",
            prop: "contactPhone",
            type: "input",
          }
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "添加",
          code: "insert",
          callback: this.addDada
        },
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "金额查询",
          code: "amountInquiry",
          callback: this.amountInquiry
        }, {
          label: "充值",
          code: "recharge",
          callback: this.recharge
        }
      ],
      // 表格信息配置
      tableOptions: {
        indexShow: true,//是否显示索引
        columns: [
          {
            label: "手机号码",
            prop: "mobile",
            width: "120",
            align: "center",
          },
          {
            label: "商户城市名称",
            prop: "cityName",
            width: "150",
            align: "center",
          },
          {
            label: "企业全称",
            prop: "enterpriseName",
            width: "150",
            align: "center",
          },
          {
            label: "企业地址",
            prop: "enterpriseAddress",
            width: "120",
            align: "center",
          },
          {
            label: "联系人姓名",
            prop: "contactName",
            width: "120",
            align: "center",
          },
          {
            label: "联系人电话",
            prop: "contactPhone",
            width: "120",
            align: "center",
          },
          {
            label: "邮箱地址",
            prop: "email",
            width: "120",
            align: "center",
          },
          {
            label: "商户编号",
            prop: "resultId",
            width: "120",
            align: "center",
          },
          {
            label: "注册时间",
            prop: "createDttm",
            width: "120",
            align: "center",
          }
        ],
        url: api.delivery.ddDeDaMerchant,
      },
      // 添加字段
      addColumns: {
        labelWidth: "120px",
        span: 12,
        columns: [
          {
            label: "手机号",
            type: "input",
            prop: "mobile",
            span: 12,
            placeholder: "请输入达达商户注册手机号",
            rule: [
              {required: true, message: "手机号", trigger: "blur"},
              {pattern: this.$utils.reg.phone, message: "请输入正确的11位手机号码", trigger: 'blur'}
            ],
          },
          {
            label: "商户城市名称",
            type: "input",
            prop: "cityName",
            span: 12,
            placeholder: "请输入商户城市名称如：苏州",
            rule: [
              {required: true, message: "商户城市名称", trigger: "blur"},
            ],
          },
          {
            label: "企业全称",
            type: "input",
            prop: "enterpriseName",
            placeholder: "请输入企业全程",
            rule: [
              {required: true, message: "企业全称", trigger: "blur"},
            ],
          },
          {
            label: "企业地址",
            type: "input",
            prop: "enterpriseAddress",
            span: 12,
            placeholder: "请输入企业详细地址",
            rule: [
              {required: true, message: "企业地址", trigger: "blur"},
            ],
          },
          {
            label: "联系人姓名",
            type: "input",
            prop: "contactName",
            span: 12,
            placeholder: "请输入联系人姓名",
            rule: [
              {required: true, message: "联系人姓名", trigger: "blur"},
            ],
          },
          {
            label: "联系人电话",
            type: "input",
            prop: "contactPhone",
            span: 12,
            placeholder: "请输入联系人手机号",
            rule: [
              {required: true, message: "联系人电话", trigger: "blur"},
            ],
          },
          {
            label: "邮箱地址",
            type: "input",
            span: 12,
            placeholder: "请输入邮箱地址",
            rule: [
              {required: true, message: "邮箱地址", trigger: "blur"},
            ],
            prop: "email",
          },
          {
            label: "商户编号",
            type: "input",
            span: 12,
            placeholder: "请输入商户编号",
            rule: [
              {required: true, message: "商户编号", trigger: "blur"},
            ],
            prop: "resultId",
          },
        ], // 表单label
        url: api.delivery.ddDeDaMerchant,
      },
    };
  },
  created(){
  },
  methods: {
    reset(){
      this.$refs.registDadaForm.resetFields();
    },
    //添加达达商户
    submitAddDada(){
      let url=api.delivery.ddDeDaMerchant;
      let data={
        ...this.registFormData
      }
      this.$refs.registDadaForm.validate((valid)=>{
        if(valid){
          this.$axios.fetchPost(url,data).then((res)=>{
            if(res.code===200){

            }else{
              this.$message.error('注册失败！'+res.errorMsg)
            }
          })
        }else{
          console.log('添写必填字段');
        }
      })
    },
    addDada(){
      this.addDadaVisible=true;
    },
    registData(){
      let url=api.delivery.dadaRegist;
      let data={
        ...this.registFormData
      }
      this.$refs.registDadaForm.validate((valid)=>{
        if(valid){
          this.$axios.fetchPost(url,data).then((res)=>{
            if(res.code===200){

            }else{
              this.$message.error('注册失败！'+res.errorMsg)
            }
          })
        }else{
          console.log('填写必填字段')
        }
      })
    },
    amountInquiry(data) {
      this.isShow = true;
      this.$axios.fetchPost(api.delivery.accountQuery, {resultId: data.resultId}).then(res => {
        if (res.code === 200) {
          this.deliverBalance = res.data.deliverBalance;
          this.redPacketBalance = res.data.redPacketBalance;
        } else {
          this.$message({message: res.errorMsg, type: "error"});
        }
      });
    },
    recharge(data) {
      this.isMoneyShow = true;
      this.form = data;
    },
    rechargeMoney() {
      this.$axios.fetchPost(api.delivery.recharge, {money: this.money, resultId: this.form.resultId}).then(res => {
        if (res.code === 200) {
          let url = res.data;
          let link = document.createElement('a')  // 创建a标签
          link.href = url;
          link.target = "_blank"
          document.body.appendChild(link)
          link.click()
          this.isMoneyShow = false;
        } else {
          this.$message({message: res.errorMsg, type: "error"});
        }
      });
    }
  },
};
</script>
<style scoped>
.setCode{
  text-align: center;
  margin-bottom: 24px;
}
</style>




// WEBPACK FOOTER //
// src/page/delivery/dd/Setting.vue